module.exports = __webpack_public_path__ + "static/media/text.33340bd0.svg";